import posthog, { type CaptureResult } from 'posthog-js'

import { isAnalyticsHost } from 'UTILS/analyticsHost'

import { normalizeRoute } from './normalizeRoute'

export const withNormalizedRoute = (event: CaptureResult | null): CaptureResult | null => {
  if (event === null) {
    return null
  }

  const pathname = event.properties?.$pathname

  if (typeof pathname === 'string') {
    event.properties.route = normalizeRoute(pathname)
  }

  return event
}

const apiKey = import.meta.env.VITE_POSTHOG_KEY

if (isAnalyticsHost() && typeof apiKey === 'string' && apiKey !== '') {
  posthog.init(apiKey, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    ui_host: 'https://us.posthog.com',
    capture_pageview: 'history_change',
    capture_pageleave: true,
    before_send: withNormalizedRoute,
  })
}

export default posthog
